// Lista curada de setores de Produção — mesmos valores de backend/data/productionSectors.js,
// precisam bater exatamente. Destino do pacote/item é livre entre esses setores, não uma
// sequência fixa (usada tanto no envio pacote-a-pacote de Produção quanto no envio inicial
// por item na tela de Compras).
export const PRODUCTION_SECTORS = [
    { value: 'Corte', label: 'Corte' },
    { value: 'Costura', label: 'Costura' },
    { value: 'Acabamento', label: 'Acabamento' },
    { value: 'Inspeção', label: 'Inspeção' },
    { value: 'Expedição', label: 'Expedição' },
    { value: 'Facção Externa', label: 'Facção Externa' },
]
